module.exports = __webpack_public_path__ + "img/clock-blue.01ab8b7d.svg";